/* Starter Shops – Verhalten aller Sections (ohne Bibliotheken)
   Desktop mit feinem Zeiger: scroll-gekoppelte Szenen (html.ss-scrub). Mobil/Touch: einmalig zeitgesteuert. */
(function () {
  'use strict';
  var cfg = window.SS_CONFIG || { motion: true, editor: false };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MOTION = cfg.motion !== false && !reduce;
  var doc = document.documentElement;
  var mqScrub = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  var mqSmall = window.matchMedia('(max-width: 749px)');
  var SCRUB = MOTION && mqScrub.matches;
  doc.classList.toggle('ss-scrub', SCRUB);
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var ease = function (t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var noanim = function (el) { return !MOTION || !!el.closest('[data-ss-noanim]'); };

  /* ---------- gemeinsame Scroll-Schleife ---------- */
  var updaters = [], measurers = [], ticking = false, tracked = [], rects = new Map();
  /* Rechteck aus dem Bild-Zwischenspeicher: alle Messungen eines Bildes passieren vor allen Schreibzugriffen */
  function R(el) { var r = rects.get(el); if (!r) { r = el.getBoundingClientRect(); rects.set(el, r); if (tracked.indexOf(el) < 0) tracked.push(el); } return r; }
  function tick() { ticking = false; var vh = window.innerHeight; rects = new Map(); for (var k = 0; k < tracked.length; k++) rects.set(tracked[k], tracked[k].getBoundingClientRect()); for (var i = 0; i < updaters.length; i++) updaters[i](vh); }
  function request() { if (!ticking) { ticking = true; requestAnimationFrame(tick); } }
  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', function () { measurers.forEach(function (m) { m(); }); request(); });
  function onView(el, cb, margin) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); cb(); } }, { rootMargin: margin || (mqSmall.matches ? '0px 0px -8% 0px' : '0px 0px -12% 0px') });
    io.observe(el);
  }
  /* Klebende Bühnen nur, solange ihre Spur im Bild ist (Safari färbt sonst die Leisten dauerhaft) */
  function live(section, track) {
    if (!('IntersectionObserver' in window)) { section.classList.add('is-live'); return; }
    new IntersectionObserver(function (en) { section.classList.toggle('is-live', en[0].isIntersecting); }, { rootMargin: '0px' }).observe(track);
  }
  /* Fortschritt einer Spur: 0 oben, 1 wenn das Ende der Spur unten ankommt */
  function progress(track, vh) { var r = R(track); var span = Math.max(1, r.height - vh); return clamp(-r.top / span, 0, 1); }

  /* ---------- Einblenden ---------- */
  function initReveal(root) {
    var els = $$('[data-ss-reveal]', root);
    if (!MOTION || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: mqSmall.matches ? '0px 0px -8% 0px' : '0px 0px -6% 0px' });
    els.forEach(function (e) { if (e.closest('[data-ss-noanim]')) e.classList.add('is-in'); else io.observe(e); });
  }
  /* Sections, die als Ganzes eine Klasse bekommen */
  function initInView(root) {
    $$('.ss-sr, .ss-sk, .ss-hero, .ss-gains, .ss-tf, [data-ss-scale]', root).forEach(function (s) {
      if (noanim(s)) { s.classList.add('is-in'); return; }
      onView(s, function () { setTimeout(function () { s.classList.add('is-in'); }, s.classList.contains('ss-hero') ? 120 : 0); }, s.classList.contains('ss-hero') || s.classList.contains('ss-sk') ? '0px' : null);
    });
  }

  /* ---------- Überschriften: Wörter steigen aus einer Maske ---------- */
  function splitWords(el, cls, delayFn) {
    var i = 0, label = el.textContent.replace(/\s+/g, ' ').trim();
    var walk = function (node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            var w = cls(part, i++, delayFn); frag.appendChild(w);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') walk(n);
      });
    };
    walk(el);
    return { count: i, label: label };
  }
  function initSplit(root) {
    $$('[data-ss-split]', root).forEach(function (el) {
      if (noanim(el) || el.hasAttribute('data-split-done')) { el.classList.add('is-split-in'); return; }
      el.setAttribute('data-split-done', '');
      var res = splitWords(el, function (part, i) {
        var o = document.createElement('span'); o.className = 'ss-split-w'; o.setAttribute('aria-hidden', 'true');
        var w = document.createElement('span'); w.textContent = part; w.style.setProperty('--d', (0.08 + i * 0.055).toFixed(3) + 's');
        o.appendChild(w); return o;
      });
      var sr = document.createElement('span'); sr.className = 'ss-sr'; sr.textContent = res.label; el.appendChild(sr);
      onView(el, function () { requestAnimationFrame(function () { el.classList.add('is-split-in'); }); }, '0px');
    });
  }

  /* ---------- Aussage: Wort für Wort aufleuchten ---------- */
  function initWords(root) {
    $$('[data-ss-words]', root).forEach(function (el) {
      if (noanim(el)) { el.classList.add('is-done'); return; }
      var words = [];
      splitWords(el, function (part) { var s = document.createElement('span'); s.className = 'ss-w'; s.textContent = part; words.push(s); return s; });
      if (SCRUB) {
        updaters.push(function (vh) {
          var r = R(el);
          var p = clamp((vh * .82 - r.top) / (r.height + vh * .38), 0, 1);
          var n = Math.round(p * words.length * 1.08);
          for (var i = 0; i < words.length; i++) words[i].classList.toggle('is-lit', i < n);
        });
      } else {
        onView(el, function () { words.forEach(function (w, i) { setTimeout(function () { w.classList.add('is-lit'); }, 60 + i * 38); }); setTimeout(function () { el.classList.add('is-done'); }, 120 + words.length * 38 + 400); }, '0px 0px -25% 0px');
      }
    });
  }

  /* ---------- Preisspanne: Anzeige rast, rastet beim Scrollen auf den Festpreis ein ---------- */
  function initSlot(root) {
    $$('[data-ss-slot]', root).forEach(function (el) {
      var min = parseFloat(el.getAttribute('data-min')) || 149, max = parseFloat(el.getAttribute('data-max')) || 15000, fix = parseFloat(el.getAttribute('data-fix')) || 1400;
      var lmin = Math.log(min), lmax = Math.log(max), pos = function (v) { return clamp((Math.log(v) - lmin) / (lmax - lmin), 0, 1) * 100; };
      el.style.setProperty('--fx', pos(fix).toFixed(2) + '%');
      var run = el.querySelector('.ss-slot__run'), locked = false, visible = false, timer = 0;
      if (!MOTION || noanim(el)) { el.classList.add('is-locked'); return; }
      var fmt = function (v) { return Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €'; };
      var spin = function () {
        var v = Math.exp(lmin + Math.random() * (lmax - lmin)); v = v > 1000 ? Math.round(v / 10) * 10 : Math.round(v);
        run.textContent = fmt(v); el.style.setProperty('--x', pos(v).toFixed(2) + '%');
      };
      var sync = function () { clearInterval(timer); if (visible && !locked) timer = setInterval(spin, 90); };
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; sync(); }).observe(el); else { visible = true; sync(); }
      updaters.push(function (vh) {
        var r = R(el);
        var on = r.top + r.height * .45 < vh * (mqSmall.matches ? .62 : .55);
        if (on !== locked) { locked = on; el.classList.toggle('is-locked', on); sync(); }
      });
    });
  }

  /* ---------- Hero: zwei Scheiben drehen sich zum Betrachter ---------- */
  function initHero(root) {
    $$('[data-ss-hero]', root).forEach(function (sec) {
      var track = sec.querySelector('.ss-hero__track'), copy = sec.querySelector('.ss-hero__copy'), scene = sec.querySelector('.ss-hero__scene');
      var tag = sec.querySelector('[data-ss-tag]');
      if (SCRUB && !noanim(sec)) {
        live(sec, track);
        var lift = 0;
        measurers.push(function () { lift = copy ? -(copy.offsetHeight * .82 + 30) : -300; sec.style.setProperty('--lift', lift + 'px'); });
        updaters.push(function (vh) {
          var p = progress(track, vh);
          var e = ease(clamp(p / .78, 0, 1));
          sec.style.setProperty('--e', e.toFixed(4)); sec.style.setProperty('--l', (1 - Math.pow(1 - clamp(p / .5, 0, 1), 3)).toFixed(4));
          if (tag) tag.classList.toggle('is-flipped', e > .38);
        });
      } else if (tag && !noanim(sec)) {
        /* mobil: Schild klappt beim Scrollen um (nur ein Klassenwechsel an einer Schwelle, die Bewegung ist eine CSS-Transition) */
        /* mobil: das erste Wischen nach oben klappt das Schild auf den Kaufpreis um, ohne zu scrollen; erst das nächste Wischen scrollt.
           Gilt nur ganz oben und nur einmal, danach scrollt die Seite ganz normal. */
        var flipped = false, hold = false, y0 = 0;
        var flip = function () { if (flipped) return; flipped = true; tag.classList.add('is-flipped'); };
        var atTop = function () { return window.scrollY < 4; };
        window.addEventListener('touchstart', function (ev) { hold = !flipped && atTop() && ev.touches.length === 1; if (hold) y0 = ev.touches[0].clientY; }, { passive: true });
        window.addEventListener('touchmove', function (ev) {
          if (!hold) return;
          var dy = y0 - ev.touches[0].clientY;
          if (!flipped && dy < 0) { hold = false; return; }
          if (ev.cancelable) ev.preventDefault();
          if (dy > 6) flip();
        }, { passive: false });
        var end = function () { hold = false; };
        window.addEventListener('touchend', end, { passive: true }); window.addEventListener('touchcancel', end, { passive: true });
        window.addEventListener('wheel', function (ev) { if (flipped || !atTop() || ev.deltaY <= 0) return; if (ev.cancelable) ev.preventDefault(); flip(); }, { passive: false });
        updaters.push(function (vh) { if (!flipped && window.scrollY > Math.min(vh * .15, 130)) flip(); });
      } else if (tag) tag.classList.add('is-flipped');
    });
  }

  /* ---------- Seitenkopf: Scheiben richten sich beim Scrollen auf (Desktop) ---------- */
  function initSk(root) {
    $$('[data-ss-sk], [data-ss-tf]', root).forEach(function (sec) {
      if (!SCRUB || noanim(sec)) return;
      updaters.push(function (vh) { var r = R(sec); var p = clamp(-r.top / (r.height * .9), 0, 1); sec.style.setProperty('--e', ease(p).toFixed(4)); });
    });
  }

  /* ---------- Seitenkopf: Preisschild klappt, Änderung wird getippt ---------- */
  function initSkScenes(root) {
    $$('[data-ss-tagloop]', root).forEach(function (t) {
      if (noanim(t)) { t.classList.add('is-flipped'); return; }
      onView(t, function () { var n = 0; var go = function () { t.classList.toggle('is-flipped'); n++; if (n < 3) setTimeout(go, 2600); }; setTimeout(go, 450); }, '0px');
    });
    $$('[data-ss-edit]', root).forEach(function (box) {
      var fields = $$('[data-ss-type]', box);
      var finish = function () { fields.forEach(function (b) { b.textContent = b.getAttribute('data-to'); b.classList.add('is-new'); }); box.classList.add('is-msg', 'is-done'); };
      if (noanim(box)) { finish(); return; }
      var type = function (el, done) {
        var to = el.getAttribute('data-to'), txt = el.getAttribute('data-from');
        el.classList.add('is-typing');
        var add = function (i) { if (i <= to.length) { el.textContent = to.slice(0, i) || '\u00a0'; setTimeout(function () { add(i + 1); }, 70); } else { el.classList.remove('is-typing'); el.classList.add('is-new'); done(); } };
        var del = function () { if (txt.length) { txt = txt.slice(0, -1); el.textContent = txt || '\u00a0'; setTimeout(del, 45); } else add(0); };
        del();
      };
      onView(box, function () {
        requestAnimationFrame(function () { box.classList.add('is-msg'); });
        var i = 0; var next = function () { if (i < fields.length) type(fields[i++], function () { setTimeout(next, 300); }); else box.classList.add('is-done'); };
        setTimeout(next, 650);
      }, '0px');
    });
  }

  /* ---------- Lösung: „Zahlen“ wandert vom Anfang ans Ende (FLIP) ---------- */
  function initUmkehr(root) {
    $$('[data-ss-flipline]', root).forEach(function (line) {
      var pay = line.querySelector('[data-ss-pay]'); if (!pay) return;
      var move = function (animate) {
        pay.style.zIndex = 2; pay.style.position = 'relative'; var items = $$('.ss-chip', line), first = items.map(function (c) { return c.getBoundingClientRect(); });
        line.appendChild(pay);
        if (!animate || !pay.animate) return;
        items.forEach(function (c, i) {
          var last = c.getBoundingClientRect(), dx = first[i].left - last.left, dy = first[i].top - last.top;
          if (!dx && !dy) return;
          if (c === pay) c.animate([{ transform: 'translate3d(' + dx + 'px,' + dy + 'px,0)', offset: 0 }, { transform: 'translate3d(' + (dx * .5).toFixed(1) + 'px,' + (dy * .5 - 14).toFixed(1) + 'px,0) scale(1.04)', offset: .5 }, { transform: 'translate3d(0,0,0)', offset: 1 }], { duration: 1150, easing: 'cubic-bezier(.45,0,.25,1)' });
          else c.animate([{ transform: 'translate3d(' + dx + 'px,' + dy + 'px,0)' }, { transform: 'translate3d(0,0,0)' }], { duration: 950, easing: 'cubic-bezier(.45,0,.25,1)', delay: 60 });
        });
      };
      if (noanim(line)) { move(false); return; }
      onView(line, function () { setTimeout(function () { move(true); }, 300); });
    });
  }

  /* ---------- Laufband: Reihen gegenläufig zum Scrollen (Desktop) ---------- */
  function initMarquee(root) {
    $$('[data-ss-mq]', root).forEach(function (sec) {
      /* Laufband bewegt sich überall zeitgesteuert (CSS); läuft nur, solange es im Bild ist */
      if (noanim(sec)) return;
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { sec.classList.toggle('is-play', en[0].isIntersecting); }, { rootMargin: '100px 0px' }).observe(sec); else sec.classList.add('is-play');
      return;
      var speed = (parseFloat(sec.getAttribute('data-speed')) || 30) / 100;
      var rows = $$('[data-ss-mqrow]', sec);
      updaters.push(function (vh) {
        var r = R(sec); if (r.bottom < -200 || r.top > vh + 200) return;
        var off = (vh - r.top) * speed;
        rows.forEach(function (row) { var dir = row.getAttribute('data-ss-mqrow') === '1' ? 1 : -1; row.firstElementChild.style.transform = 'translate3d(' + (dir * (off - 260)).toFixed(1) + 'px,0,0)'; });
      });
    });
  }

  /* ---------- Neigen mit dem Zeiger (Preisschild, Auswahlkarten) ---------- */
  function initTilt(root) {
    /* Touch-Geräte: Preisschild dreht sich beim Scrollen leicht um die eigene Achse nach rechts und gleitet wenige Pixel mit */
    if (MOTION && !window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      $$('.ss-ps__tagwrap[data-ss-tilt]', root).forEach(function (el) {
        if (noanim(el)) return;
        /* Ziel aus der Scrollposition, die Bewegung folgt weich nachgeführt im eigenen Bildtakt (gleichmäßig, auch wenn Safari Scroll-Ereignisse stoßweise liefert) */
        var target = 0, cur = null, raf = 0, last = 0;
        var paint = function () { el.style.transform = 'perspective(900px) translate3d(0,' + (cur * 14).toFixed(2) + 'px,0) rotateY(' + (-cur * 9).toFixed(3) + 'deg) rotate(' + (cur * 1.5).toFixed(3) + 'deg)'; };
        var loop = function (t) {
          raf = 0; var dt = last ? Math.min(64, t - last) : 16.7; last = t;
          cur += (target - cur) * (1 - Math.pow(1 - .14, dt / 16.7));
          if (Math.abs(target - cur) < .0005) cur = target;
          paint(); if (cur !== target) raf = requestAnimationFrame(loop); else last = 0;
        };
        updaters.push(function (vh) {
          var r = R(el); if (r.bottom < -150 || r.top > vh + 150) return;
          target = clamp((r.top + r.height / 2) / vh, 0, 1) * 2 - 1;
          if (cur === null) { cur = target; paint(); return; }
          if (!raf) raf = requestAnimationFrame(loop);
        });
      });
      return;
    }
    if (!MOTION) return;
    $$('[data-ss-tilt]', root).forEach(function (el) {
      var target = el.querySelector('.ss-pane--tag') || el;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        if (target === el) { el.style.setProperty('--ry', (x * 6).toFixed(2) + 'deg'); el.style.setProperty('--rx', (-y * 6).toFixed(2) + 'deg'); }
        else { target.style.transform = 'rotateY(' + (-14 + x * 16).toFixed(2) + 'deg) rotateX(' + (6 - y * 12).toFixed(2) + 'deg) rotateZ(-4deg)'; }
      });
      el.addEventListener('pointerleave', function () { el.style.removeProperty('--ry'); el.style.removeProperty('--rx'); if (target !== el) target.style.transform = ''; });
    });
  }

  /* ---------- Geräte-Schaubild: aktiver Punkt steuert die Ansicht ---------- */
  function initGeraete(root) {
    $$('[data-ss-gr]', root).forEach(function (sec) {
      var items = $$('[data-ss-gritem]', sec), dev = sec.querySelector('[data-ss-device]'), track = sec.querySelector('.ss-gr__track');
      var set = function (i) {
        items.forEach(function (it, k) { it.classList.toggle('is-on', k === i); });
        var mode = items[i] ? items[i].getAttribute('data-mode') : 'desk';
        dev.classList.toggle('is-phone', mode === 'phone');
        /* einmal durchgescrollt, bleibt die Website unten stehen (springt beim Handy nicht wieder nach oben); erst beim Zurückscrollen davor geht sie hoch */
        var reached = items.slice(0, i + 1).some(function (it) { return it.getAttribute('data-mode') === 'scroll'; });
        dev.classList.toggle('is-scroll', reached);
      };
      if (SCRUB && !noanim(sec)) {
        live(sec, track);
        var cur = -1;
        updaters.push(function (vh) { var p = progress(track, vh); var i = Math.min(items.length - 1, Math.floor(p * items.length * .999)); if (i !== cur) { cur = i; set(i); } });
        items.forEach(function (it, k) { it.style.cursor = 'pointer'; it.addEventListener('click', function () { var r = track.getBoundingClientRect(); window.scrollTo({ top: window.scrollY + r.top + (k + .5) / items.length * (track.offsetHeight - window.innerHeight), behavior: 'smooth' }); }); });
      } else {
        /* mobil: alle Punkte sichtbar, das Gerät wechselt zeitgesteuert, sobald es im Bild ist */
        items.forEach(function (it) { it.classList.add('is-on'); });
        if (noanim(sec)) return;
        var k = Math.max(0, items.map(function (i) { return i.getAttribute('data-mode'); }).indexOf('scroll')), timer = 0;
        onView(dev, function () { var step = function () { var modes = items.map(function (i) { return i.getAttribute('data-mode'); }); var m = modes[k % modes.length]; dev.classList.toggle('is-phone', m === 'phone'); dev.classList.toggle('is-scroll', m === 'scroll'); k++; if (k < modes.length * 2) timer = setTimeout(step, m === 'scroll' ? 16800 : 3200); }; step(); });
      }
    });
  }

  /* ---------- Ablauf gestapelt: Karten schieben sich übereinander (Desktop) ---------- */
  function initStapel(root) {
    $$('[data-ss-sp]', root).forEach(function (sec) {
      var cards = $$('[data-ss-spcard]', sec), nav = $$('[data-ss-spnav]', sec), track = sec.querySelector('.ss-sp__track'), stack = sec.querySelector('.ss-sp__stack');
      var rail = sec.querySelector('.ss-sp__rail'), fill = rail && rail.querySelector('i');
      if (noanim(sec) || !cards.length) { cards.forEach(function (c) { c.classList.add('is-on'); }); if (fill) fill.style.transform = 'none'; return; }
      if (!SCRUB) {
        /* mobil: lila Linie läuft beim Scrollen mit und verbindet die Schrittzahlen; erreichte Schritte leuchten */
        var nos = cards.map(function (c) { return c.querySelector('.ss-sp__no'); }), mids = [], rt = 0, rh = 1, lastP = -1;
        measurers.push(function () {
          var s = stack.getBoundingClientRect();
          mids = nos.map(function (n) { var r = n.getBoundingClientRect(); return r.top + r.height / 2 - s.top; });
          rt = mids[0] || 0; rh = Math.max(1, (mids[mids.length - 1] || 1) - rt);
          if (rail) { rail.style.top = rt + 'px'; rail.style.height = rh + 'px'; }
        });
        updaters.push(function (vh) {
          var r = R(stack); if (r.bottom < -100 || r.top > vh + 100) return;
          var line = vh * .62 - r.top, p = clamp((line - rt) / rh, 0, 1);
          if (Math.abs(p - lastP) > .0005) { lastP = p; if (fill) fill.style.transform = 'scaleY(' + p.toFixed(4) + ')'; }
          cards.forEach(function (c, i) { c.classList.toggle('is-on', mids[i] <= line + 1); });
        });
        return;
      }
      live(sec, track);
      /* Desktop: vorherige Karten bleiben als schmale Kante sichtbar und treten zurück; die aktive Karte hat immer die volle Höhe.
         Nur transform und Deckkraft, Fortschritt weich nachgeführt (eigener rAF, endet, sobald er steht). */
      var n = cards.length, H = 0, VH = window.innerHeight, peek = 18, target = 0, cur = 0, raf = 0, shown = -1;
      measurers.push(function () { H = stack.clientHeight; });
      var apply = function (raw) {
        var active = Math.min(n - 1, Math.round(raw));
        cards.forEach(function (c, i) {
          var y = 0, depth = clamp(raw - i, 0, n), s = 1 - Math.min(depth, 4) * .035;
          if (i) { var e = ease(clamp(raw - (i - 1), 0, 1)); y = (1 - e) * (VH + 60) + e * i * peek; }
          c.style.transform = 'translate3d(0,' + y.toFixed(2) + 'px,0) scale(' + s.toFixed(4) + ')';
          c.style.setProperty('--dim', Math.min(.6, depth * .26).toFixed(3));
          c.style.zIndex = i + 1;
        });
        if (active !== shown) { shown = active; cards.forEach(function (c, i) { c.classList.toggle('is-on', i === active); }); nav.forEach(function (x, i) { x.classList.toggle('is-on', i === active); }); }
      };
      var loop = function () { raf = 0; cur += (target - cur) * .16; if (Math.abs(target - cur) < .0008) cur = target; apply(cur); if (cur !== target) raf = requestAnimationFrame(loop); };
      updaters.push(function (vh) { VH = vh; target = Math.min(n - 1, progress(track, vh) * (n - 1) * 1.08); if (!raf) raf = requestAnimationFrame(loop); });
    });
  }

  /* ---------- Vorher/Nachher: Schieber (Maus, Finger, Tastatur), beide Seiten laufen nur im Bild durch ---------- */
  function initVergleich(root) {
    $$('[data-ss-vg]', root).forEach(function (sec) {
      var view = sec.querySelector('[data-ss-vgview]'), before = sec.querySelector('[data-ss-vgbefore]'), line = sec.querySelector('[data-ss-vgline]'), knob = sec.querySelector('.ss-vg__knob');
      if (!view || !before || !line) return;
      var W = 0, p = (parseFloat(getComputedStyle(view).getPropertyValue('--p')) || 50) / 100, touched = false, drag = false;
      var set = function (v) { p = clamp(v, 0, 1); var x = W * p; line.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)'; before.style.clipPath = 'inset(0 ' + (W - x).toFixed(1) + 'px 0 0)'; if (knob) knob.setAttribute('aria-valuenow', Math.round(p * 100)); };
      var measure = function () { W = view.clientWidth; set(p); };
      measurers.push(measure); measure();
      var at = function (e) { var r = view.getBoundingClientRect(); set((e.clientX - r.left) / r.width); };
      view.addEventListener('pointerdown', function (e) { if (e.button > 0) return; touched = true; drag = true; sec.classList.add('is-drag'); if (e.pointerType === 'mouse') { view.setPointerCapture(e.pointerId); at(e); } else { view._x0 = e.clientX; view._y0 = e.clientY; view._dir = 0; } });
      view.addEventListener('pointermove', function (e) {
        if (!drag) return;
        if (e.pointerType !== 'mouse' && !view._dir) { var dx = Math.abs(e.clientX - view._x0), dy = Math.abs(e.clientY - view._y0); if (dx < 6 && dy < 6) return; view._dir = dx > dy ? 1 : -1; if (view._dir > 0) view.setPointerCapture(e.pointerId); }
        if (e.pointerType === 'mouse' || view._dir > 0) at(e);
      });
      var end = function () { drag = false; sec.classList.remove('is-drag'); };
      view.addEventListener('pointerup', end); view.addEventListener('pointercancel', end);
      if (knob) knob.addEventListener('keydown', function (e) { var k = e.key; if (k === 'ArrowLeft' || k === 'ArrowDown') { e.preventDefault(); touched = true; set(p - .05); } else if (k === 'ArrowRight' || k === 'ArrowUp') { e.preventDefault(); touched = true; set(p + .05); } else if (k === 'Home') { e.preventDefault(); set(0); } else if (k === 'End') { e.preventDefault(); set(1); } });
      if (noanim(sec) || !('IntersectionObserver' in window)) return;
      /* Durchlauf nur, solange die Section im Bild ist; beim ersten Hereinkommen zeigt der Regler kurz, dass er sich bewegen lässt */
      var hinted = false;
      new IntersectionObserver(function (en) {
        var on = en[0].isIntersecting; sec.classList.toggle('is-play', on);
        if (on && !hinted) {
          hinted = true; var p0 = p, t0 = 0, D = 1700;
          var step = function (t) { if (touched) return; if (!t0) t0 = t; var k = Math.min(1, (t - t0) / D); var w = Math.sin(k * Math.PI * 2) * (1 - k) * .16; set(p0 - w); if (k < 1) requestAnimationFrame(step); else set(p0); };
          setTimeout(function () { requestAnimationFrame(step); }, 500);
        }
      }, { threshold: .35 }).observe(view);
    });
  }

  /* ---------- ss-cookie-link: „Cookie-Richtlinie“ der Consent-App führt zu den Datenschutzbestimmungen ---------- */
  (function () {
    var URL_DS = '/policies/privacy-policy', SEL = 'a.iubenda-cs-cookie-policy-lnk, a[href*="/pages/cookie-policy"]';
    var LABEL = 'Datenschutzerklärung', URL_IM = '/policies/legal-notice';
    var fix = function () {
      $$(SEL, document).forEach(function (a) {
        if (a.getAttribute('href') !== URL_DS) a.setAttribute('href', URL_DS);
        if (a.closest('#iubenda-cs-banner') && a.textContent !== LABEL) { a.textContent = LABEL; a.setAttribute('aria-label', LABEL + ' (öffnet in neuem Tab)'); a.removeAttribute('role'); }
      });
      var box = document.querySelector('#iubenda-cs-banner #iubenda-cs-paragraph');
      if (box && !document.querySelector('.ss-cb-links')) {
        var row = document.createElement('p'); row.className = 'ss-cb-links';
        row.innerHTML = '<a href="' + URL_DS + '" target="_blank" rel="noopener">Datenschutz</a><a href="' + URL_IM + '" target="_blank" rel="noopener">Impressum</a>';
        box.parentNode.insertBefore(row, box.nextSibling);
      }
    };
    var queued = false;
    new MutationObserver(function () { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; fix(); }); }).observe(document.documentElement, { childList: true, subtree: true });
    ['pointerdown', 'touchstart'].forEach(function (ev) { document.addEventListener(ev, fix, { capture: true, passive: true }); });
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest(SEL)) { fix(); e.stopImmediatePropagation(); return; } /* Standard-Linkverhalten öffnet die Seite */
      if (e.target.closest('#iubenda-iframe .purposes-header .iub-btn-cp')) {
        e.preventDefault(); e.stopImmediatePropagation();
        var w = window.open(URL_DS, '_blank'); if (!w) location.href = URL_DS;
      }
    }, true);
    fix();
  })();

  /* ---------- Widerruf: erst „Vertrag widerrufen“, dann Angaben prüfen und „Widerruf bestätigen“ (§ 356a BGB) ---------- */
  function initWiderruf(root) {
    $$('[data-ss-wd]', root).forEach(function (sec) {
      var KEY = 'ss-widerruf', sum = sec.querySelector('[data-ss-wdsum]');
      if (sum) {
        var saved = null; try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); sessionStorage.removeItem(KEY); } catch (e) {}
        if (saved) { saved.forEach(function (r) { var dt = document.createElement('dt'), dd = document.createElement('dd'); dt.textContent = r[0]; dd.textContent = r[1]; sum.appendChild(dt); sum.appendChild(dd); }); sum.hidden = false; }
        return;
      }
      var form = sec.querySelector('form'), next = sec.querySelector('[data-ss-wdnext]'), review = sec.querySelector('[data-ss-wdreview]'), back = sec.querySelector('[data-ss-wdback]'), list = sec.querySelector('[data-ss-wdlist]'), time = sec.querySelector('[data-ss-wdtime]');
      if (!form || !next || !review) return;
      var rows = function () {
        return [['Name', form.querySelector('[name="contact[Name]"]').value], ['E-Mail', form.querySelector('[name="contact[email]"]').value], ['Vertrag', form.querySelector('[name="contact[body]"]').value]];
      };
      var close = function () { review.classList.remove('is-open'); doc.classList.remove('ss-wd-open'); next.focus(); };
      next.addEventListener('click', function () {
        if (!form.reportValidity()) return;
        list.textContent = '';
        rows().forEach(function (r) { var dt = document.createElement('dt'), dd = document.createElement('dd'); dt.textContent = r[0]; dd.textContent = r[1]; list.appendChild(dt); list.appendChild(dd); });
        review.classList.add('is-open'); doc.classList.add('ss-wd-open');
        review.querySelector('button[type="submit"]').focus();
      });
      back.addEventListener('click', close);
      review.addEventListener('click', function (e) { if (e.target === review) close(); });
      review.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); return; }
        if (e.key !== 'Tab') return;
        var b = $$('button', review), first = b[0], last = b[b.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); } else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      form.addEventListener('submit', function () {
        var now = new Date().toLocaleString('de-DE', { dateStyle: 'medium', timeStyle: 'short' });
        if (time) time.value = now;
        try { sessionStorage.setItem(KEY, JSON.stringify(rows().concat([['Abgesendet am', now]]))); } catch (e) {}
      });
    });
  }

  /* ---------- Ablauf: Branche wird in die Fragebogen-Karte getippt ---------- */
  function initTypeOnce(root) {
    $$('[data-ss-typeonce]', root).forEach(function (el) {
      if (noanim(el)) return;
      var full = el.getAttribute('data-ss-typeonce'), card = el.closest('.ss-sp__card'), done = false;
      el.textContent = '\u00a0';
      var go = function () {
        if (done) return; done = true; el.classList.add('is-typing');
        var i = 0; var step = function () { i++; el.textContent = full.slice(0, i); if (i < full.length) setTimeout(step, 75); else setTimeout(function () { el.classList.remove('is-typing'); }, 900); };
        setTimeout(step, 400);
      };
      if (SCRUB && card) { var mo = new MutationObserver(function () { if (card.classList.contains('is-on')) go(); }); mo.observe(card, { attributes: true, attributeFilter: ['class'] }); if (card.classList.contains('is-on')) go(); }
      else onView(el, go);
    });
  }

  /* ---------- Redaktionsservice-Uhr: füllt sich, verfällt am Monatsende ---------- */
  function initClock(root) {
    $$('[data-ss-clock]', root).forEach(function (cl) {
      var fill = cl.querySelector('.ss-rd__fill'), months = $$('.ss-rd__months span', cl);
      var mins = parseFloat(cl.querySelector('.ss-rd__num b').textContent) || 30, full = clamp(mins / 60 * 100, 5, 100);
      var setF = function (v) { cl.style.setProperty('--f', v); };
      if (noanim(cl)) { setF(full); if (months[0]) months[months.length - 1].classList.add('is-on'); return; }
      setF(0.001);
      onView(cl, function () {
        var m = 0;
        var cycle = function () {
          months.forEach(function (s, k) { s.classList.toggle('is-on', k === m); });
          setF(full);
          if (m < months.length - 1) setTimeout(function () { setF(0.001); m++; setTimeout(cycle, 1100); }, 2300);
        };
        setTimeout(cycle, 200);
      });
    });
  }

  /* ---------- FAQ: weich auf- und zuklappen ----------
     Die Höhe springt einmal, danach läuft nur noch transform und opacity auf der GPU.
     Eine Höhen-Animation setzt jedes Bild neu und lässt den Text darunter zittern. */
  function initAcc(root) {
    var EASE = 'cubic-bezier(.23,1,.32,1)', pending = null;
    var box = function (el) { return el.getBoundingClientRect(); };
    var below = function (d, shift) {
      var out = [], main = document.getElementById('MainContent'), el = d, vh = window.innerHeight, ft = document.querySelector('.ss-ft');
      while (el && el !== main && el.parentNode) { for (var s = el.nextElementSibling; s; s = s.nextElementSibling) out.push(s); el = el.parentNode; }
      if (ft) out.push(ft);
      return out.filter(function (e) { var r = box(e); return r.height && r.top < vh + shift && r.bottom > -shift; });
    };
    /* translate statt transform: mobil sperrt [data-ss-reveal] transform mit !important */
    var slide = function (els, from, to, dur, delay) {
      return els.map(function (e) { return e.animate([{ translate: '0 ' + from + 'px' }, { translate: '0 ' + to + 'px' }], { duration: dur, delay: delay, easing: EASE, fill: 'both' }); });
    };
    var track = function (all, end) {
      var left = all.length;
      var done = function () { pending = null; if (end) end(); all.forEach(function (a) { a.cancel(); }); };
      all.forEach(function (a) { a.onfinish = function () { if (!--left) done(); }; });
      pending = done;
    };
    $$('.ss-acc', root).forEach(function (d) {
      var sum = d.querySelector('summary'), body = d.querySelector('.ss-acc__body');
      if (!body || !body.animate || !MOTION) return;
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        if (pending) pending();
        if (d.open) {
          /* Weg exakt messen, Safari setzt die Frage im offenen Zustand minimal anders */
          var h1 = box(d).height; d.open = false; var sh = h1 - box(d).height; d.open = true;
          d.classList.add('is-closing');
          track(slide(below(d, sh), 0, -sh, 240, 30).concat(body.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 90, easing: 'ease-out', fill: 'both' })), function () { d.open = false; d.classList.remove('is-closing'); });
        } else {
          var h0 = box(d).height; d.open = true; var sh2 = box(d).height - h0;
          track(slide(below(d, sh2), -sh2, 0, 280, 0).concat(body.animate([{ opacity: 0, translate: '0 -6px' }, { opacity: 1, translate: '0 0' }], { duration: 240, delay: 60, easing: EASE, fill: 'both' })));
        }
      });
    });
  }

  /* ---------- Referenzen: Vorschau läuft nur, solange die Kachel im Bild ist ---------- */
  function initScrollShots(root) {
    var cards = $$('.ss-rs__card', root).filter(function (c) { return c.querySelector('[data-ss-scrollshot]'); });
    if (!cards.length || !MOTION) return;
    if (!('IntersectionObserver' in window)) { cards.forEach(function (c) { c.classList.add('is-play'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { e.target.classList.toggle('is-play', e.isIntersecting); }); }, { rootMargin: '10% 0px' });
    cards.forEach(function (c) { if (!c.closest('[data-ss-noanim]')) io.observe(c); });
  }

  /* ---------- Referenzen: Filter ---------- */
  function initFilter(root) {
    $$('[data-ss-filter]', root).forEach(function (bar) {
      var grid = bar.parentNode.querySelector('.ss-rs__grid'); if (!grid) return;
      $$('button', bar).forEach(function (b) {
        b.addEventListener('click', function () {
          var f = b.getAttribute('data-f');
          $$('button', bar).forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          $$('.ss-rs__card', grid).forEach(function (c) { c.hidden = !(f === 'alle' || c.getAttribute('data-kind') === f); });
        });
      });
    });
  }

  /* ---------- Lightbox ---------- */
  var lb, lbList = [], lbIdx = 0, lbLast = null;
  function lbShow(i) { lbIdx = (i + lbList.length) % lbList.length; var src = lbList[lbIdx]; var img = lb.querySelector('img'); var set = (src.getAttribute('srcset') || '').split(',').map(function (x) { return x.trim().split(/\s+/)[0]; }).filter(Boolean); img.src = set.length ? set[set.length - 1] : (src.currentSrc || src.src); img.alt = src.alt || ''; var tall = src.naturalHeight > src.naturalWidth * 1.6; lb.classList.toggle('is-tall', tall); lb.scrollTop = 0;
    /* hohe Seiten laufen wie in der Kachel von oben nach unten durch; Dauer nach Seitenlänge */
    var view = lb.querySelector('.ss-lb__view'); view.classList.remove('is-manual'); view.scrollTop = 0;
    lb.style.setProperty('--ar', (src.naturalHeight / src.naturalWidth).toFixed(4)); if (tall) lb.style.setProperty('--lbdur', Math.round(clamp(src.naturalHeight / src.naturalWidth * 5.2, 16, 45)) + 's');
    img.style.animation = 'none'; void img.offsetWidth; img.style.animation = ''; }
  function lbClose() { lb.classList.remove('is-open'); doc.classList.remove('ss-lb-open'); if (lbLast) lbLast.focus(); }
  function initLightbox(root) {
    var zooms = $$('[data-ss-zoom]', root); if (!zooms.length) return;
    if (!lb) {
      lb = document.createElement('div'); lb.className = 'ss-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Bildansicht');
      var ic = function (d) { return '<svg class="ss-ic" viewBox="0 0 24 24" aria-hidden="true">' + d + '</svg>'; };
      lb.innerHTML = '<div class="ss-lb__view"><img alt=""></div><button type="button" class="ss-lb__x" aria-label="Schließen">' + ic('<path d="M6 6l12 12M18 6 6 18"/>') + '</button><button type="button" class="ss-lb__p" aria-label="Vorheriges Bild">' + ic('<path d="M15 6l-6 6 6 6"/>') + '</button><button type="button" class="ss-lb__n" aria-label="Nächstes Bild">' + ic('<path d="m9 6 6 6-6 6"/>') + '</button>';
      document.body.appendChild(lb);
      lb.querySelector('.ss-lb__x').addEventListener('click', lbClose);
      /* Antippen oder Scrollen: Durchlauf stoppt an der aktuellen Stelle, danach scrollt man selbst */
      var lbView = lb.querySelector('.ss-lb__view'), lbImg = lbView.querySelector('img');
      var manual = function () { if (!lb.classList.contains('is-tall') || lbView.classList.contains('is-manual')) return; var t = getComputedStyle(lbImg).transform, y = 0; if (t && t !== 'none' && window.DOMMatrix) y = -new DOMMatrix(t).m42; lbView.classList.add('is-manual'); lbView.scrollTop = y; };
      ['pointerdown', 'wheel', 'touchstart'].forEach(function (ev) { lbView.addEventListener(ev, manual, { passive: true }); });
      lb.querySelector('.ss-lb__p').addEventListener('click', function () { lbShow(lbIdx - 1); });
      lb.querySelector('.ss-lb__n').addEventListener('click', function () { lbShow(lbIdx + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); });
      document.addEventListener('keydown', function (e) { if (!lb.classList.contains('is-open')) return; if (e.key === 'Escape') lbClose(); if (e.key === 'ArrowLeft') lbShow(lbIdx - 1); if (e.key === 'ArrowRight') lbShow(lbIdx + 1); });
    }
    zooms.forEach(function (z) {
      z.addEventListener('click', function () {
        var group = z.closest('[data-ss-lbgroup]');
        var btns = group ? $$('[data-ss-zoom]', group) : [z];
        lbList = btns.map(function (b) { return b.querySelector('img'); }).filter(Boolean);
        var one = lbList.length < 2; lb.querySelector('.ss-lb__p').hidden = one; lb.querySelector('.ss-lb__n').hidden = one;
        lbLast = z; lbShow(Math.max(0, btns.indexOf(z))); lb.classList.add('is-open'); doc.classList.add('ss-lb-open'); lb.querySelector('.ss-lb__x').focus();
      });
    });
  }

  /* ---------- Slider ---------- */
  function initSliders(root) {
    $$('[data-ss-slider]', root).forEach(function (s) {
      var view = s.querySelector('.ss-sl__view'), prev = s.querySelector('[data-ss-prev]'), next = s.querySelector('[data-ss-next]');
      if (!view) return;
      var by = function (d) { var it = view.querySelector('.ss-sl__item'); view.scrollBy({ left: d * (it ? it.offsetWidth + 20 : 400), behavior: MOTION ? 'smooth' : 'auto' }); };
      var upd = function () { if (prev) prev.disabled = view.scrollLeft < 8; if (next) next.disabled = view.scrollLeft + view.clientWidth > view.scrollWidth - 8; };
      if (prev) prev.addEventListener('click', function () { by(-1); }); if (next) next.addEventListener('click', function () { by(1); });
      view.addEventListener('scroll', upd, { passive: true }); upd();
    });
  }

  /* ---------- Video erst nach Klick laden (Datenschutz) ---------- */
  function initConsent(root) {
    $$('[data-ss-consent]', root).forEach(function (c) {
      var b = c.querySelector('button'); if (!b) return;
      b.addEventListener('click', function () { var f = document.createElement('iframe'); f.src = c.getAttribute('data-src'); f.allow = 'autoplay; fullscreen; picture-in-picture'; f.title = 'Video'; c.appendChild(f); b.remove(); });
    });
  }

  /* ---------- Blog-Artikel: Inhaltsverzeichnis ---------- */
  function initToc(root) {
    $$('[data-ss-ar]', root).forEach(function (ar) {
      var toc = ar.querySelector('[data-ss-toc]'), prose = ar.querySelector('[data-ss-prose]'); if (!toc || !prose) return;
      var hs = $$('h2, h3', prose); if (hs.length < 2) return;
      var ol = toc.querySelector('ol'), links = [];
      hs.forEach(function (h, i) {
        if (!h.id) h.id = 'abschnitt-' + (i + 1) + '-' + h.textContent.toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
        var li = document.createElement('li'); if (h.tagName === 'H3') li.className = 'is-sub';
        var a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent; li.appendChild(a); ol.appendChild(li); links.push(a);
      });
      toc.hidden = false;
      updaters.push(function () { var cur = 0; hs.forEach(function (h, i) { if (R(h).top < 140) cur = i; }); links.forEach(function (a, i) { a.classList.toggle('is-on', i === cur); }); });
    });
  }

  /* ---------- Konfigurator: ein Schritt pro Bildschirm ---------- */
  function initKonfig(root) {
    $$('[data-ss-kf]', root).forEach(function (sec) {
      var form = sec.querySelector('form'); if (!form) return;
      var done = sec.querySelector('[data-ss-done]');
      if (done) {
        try { if (sessionStorage.getItem('ss-logo-mail') === 'nein') { var h = done.querySelector('[data-ss-logohint]'); if (h) h.hidden = true; } } catch (e) {}
        setTimeout(function () { done.scrollIntoView({ block: 'center' }); done.focus({ preventScroll: true }); }, 200);
        return;
      }
      var steps = $$('.ss-kf__step', form); if (!steps.length) return;
      var prev = form.querySelector('[data-ss-prev]'), next = form.querySelector('[data-ss-next]'), bar = form.querySelector('[data-ss-bar]'), count = form.querySelector('[data-ss-count]'), msg = form.querySelector('[data-ss-msg]'), sum = form.querySelector('[data-ss-sum]');
      var cur = 0;
      sec.classList.add('is-ready');
      /* Logo-Auswahl hängt davon ab, ob eine Adresse eingetragen ist */
      var url = form.querySelector('input[name="contact[Bestehende Website]"]'), logo = form.querySelector('[data-ss-logo]');
      var syncLogo = function () {
        if (!logo) return; var has = url && url.value.trim().length > 3;
        $$('.ss-opt[data-when]', logo).forEach(function (o) { var w = o.getAttribute('data-when'); var off = w === 'url' ? !has : w === 'nourl' ? has : false; o.classList.toggle('is-off', off); if (off) { var i = o.querySelector('input'); if (i.checked) i.checked = false; } });
      };
      if (url) url.addEventListener('input', syncLogo); syncLogo();
      /* Schritte ohne Pflichtfeld lassen sich überspringen, der Button sagt das auch */
      var syncNext = function () {
        var st = steps[cur], filled = $$('input:not([type=hidden]), textarea', st).some(function (el) { return el.type === 'checkbox' || el.type === 'radio' ? el.checked : el.value.trim(); });
        next.querySelector('span').textContent = !st.querySelector('[required]') && !filled ? 'Überspringen' : 'Weiter';
      };
      var show = function (i, back) {
        cur = clamp(i, 0, steps.length - 1);
        steps.forEach(function (s, k) { s.classList.toggle('is-on', k === cur); s.classList.toggle('is-back', !!back && k === cur); });
        sec.classList.toggle('is-last', cur === steps.length - 1);
        prev.hidden = cur === 0;
        if (bar) bar.style.setProperty('--p', ((cur + 1) / steps.length).toFixed(3));
        if (count) count.textContent = 'Schritt ' + (cur + 1) + ' von ' + steps.length;
        if (msg) msg.hidden = true;
        syncNext();
        if (cur === steps.length - 1) buildSummary();
      };
      var focusStep = function () { var f = steps[cur].querySelector('input:not([type=hidden]):not([disabled]), textarea'); var top = sec.querySelector('.ss-kf__panel').getBoundingClientRect().top; if (top < 0 || top > window.innerHeight * .5) sec.querySelector('.ss-kf__panel').scrollIntoView({ behavior: MOTION ? 'smooth' : 'auto', block: 'start' }); if (f && !mqSmall.matches) setTimeout(function () { f.focus({ preventScroll: true }); }, 60); };
      /* Adresse freundlich prüfen: leer bleibt erlaubt, Tippfehler bremsen sanft */
      var urlOk = function (el) {
        var v = el.value.trim().replace(/^https?:\/\//i, '');
        var ok = !v || /^[^\s@\/]+\.[a-zäöü]{2,}(\/\S*)?$/i.test(v);
        el.value = v; el.setCustomValidity(ok ? '' : 'Bitte gib eine Web-Adresse ein, z. B. www.deine-firma.de');
        var hint = el.parentNode.nextElementSibling;
        if (hint && hint.classList.contains('ss-fs__urlhint')) hint.hidden = ok;
      };
      $$('[data-ss-url]', form).forEach(function (el) { el.addEventListener('blur', function () { urlOk(el); }); });
      var valid = function (step) {
        var bad = null;
        $$('[data-ss-url]', step).forEach(urlOk);
        $$('input, textarea', step).forEach(function (el) {
          if (el.type === 'hidden' || el.disabled) return;
          var ok = el.checkValidity();
          var wrap = el.type === 'checkbox' || el.type === 'radio' ? el.closest('.ss-opt') : el;
          if (wrap) wrap.classList.toggle('is-bad', !ok);
          if (!ok && !bad) bad = el;
        });
        if (bad) {
          if (msg) { msg.textContent = bad.type === 'email' && bad.value ? 'Bitte prüfe deine E-Mail-Adresse.' : bad.type === 'checkbox' ? 'Bitte bestätige das Kästchen, um fortzufahren.' : 'Bitte fülle die markierten Felder aus.'; msg.hidden = false; }
          bad.focus(); return false;
        }
        return true;
      };
      form.addEventListener('input', function (e) { syncNext(); var w = e.target.type === 'checkbox' || e.target.type === 'radio' ? e.target.closest('.ss-opt') : e.target; if (w && e.target.checkValidity()) w.classList.remove('is-bad'); });
      next.addEventListener('click', function () { if (!valid(steps[cur])) return; show(cur + 1); focusStep(); });
      prev.addEventListener('click', function () { show(cur - 1, true); focusStep(); });
      form.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.tagName === 'INPUT' && e.target.type !== 'checkbox' && cur < steps.length - 1) { e.preventDefault(); next.click(); } });
      /* Mehrfachauswahlen zusammenführen: „Modern, Wenige Animationen“ */
      var merge = function () {
        $$('[data-ss-merge]', form).forEach(function (fs) {
          var vals = $$('input[type=checkbox]', fs).filter(function (c) { return c.checked; }).map(function (c) { return c.getAttribute('data-label'); });
          var hid = fs.querySelector('[data-ss-merged]'); hid.value = vals.join(', '); hid.disabled = !vals.length;
          $$('input[type=checkbox]', fs).forEach(function (c) { c.disabled = true; });
        });
      };
      var unmerge = function () { $$('[data-ss-merge] input[type=checkbox]', form).forEach(function (c) { c.disabled = false; }); };
      function buildSummary() {
        if (!sum) return;
        var dl = sum.querySelector('dl'); dl.innerHTML = '';
        var rows = [];
        var legend = function (fs) { return fs.querySelector('legend').textContent.replace('(optional)', '').trim(); };
        var label = function (el) { var f = el.closest('.ss-f'); if (f) return f.querySelector('label').childNodes[0].textContent.trim(); var fs = el.closest('fieldset.ss-fs'); return fs ? legend(fs) : el.name; };
        var seen = {};
        $$('input, textarea', form).forEach(function (el) {
          if (el.type === 'hidden' || el.closest('.ss-kf__step') === steps[steps.length - 1] && el.type === 'checkbox') return;
          if (el.type === 'checkbox') { var fs = el.closest('[data-ss-merge]'); if (!fs || !el.checked) { if (!fs && el.checked) rows.push(['Bestätigt', el.closest('.ss-opt').textContent.trim()]); return; } var k = fs.getAttribute('data-ss-merge'); if (seen[k]) return; seen[k] = 1; rows.push([legend(fs), $$('input:checked', fs).map(function (c) { return c.getAttribute('data-label'); }).join(', ')]); return; }
          if (el.type === 'radio') { if (el.checked) rows.push([label(el), el.value]); return; }
          if (el.value.trim()) rows.push([label(el), el.value.trim()]);
        });
        rows.forEach(function (r) { var d = document.createElement('div'); var dt = document.createElement('dt'); dt.textContent = r[0]; var dd = document.createElement('dd'); dd.textContent = r[1]; d.appendChild(dt); d.appendChild(dd); dl.appendChild(d); });
        sum.hidden = !rows.length;
      }
      var edit = sum && sum.querySelector('[data-ss-edit]'); if (edit) edit.addEventListener('click', function () { show(0, true); focusStep(); });
      form.addEventListener('submit', function (e) {
        for (var i = 0; i < steps.length; i++) { if (!valid(steps[i])) { e.preventDefault(); show(i); valid(steps[i]); return; } }
        var lg = form.querySelector('input[name="contact[Logo]"]:checked');
        try { sessionStorage.setItem('ss-logo-mail', lg && /Mail/.test(lg.value) ? 'ja' : 'nein'); } catch (err) {}
        merge();
        var btn = form.querySelector('[data-ss-submit]'); if (btn) { btn.setAttribute('aria-busy', 'true'); btn.querySelector('span').textContent = 'Wird gesendet …'; }
        setTimeout(unmerge, 4000);
      });
      show(0);
    });
  }

  /* ---------- Zeitleiste: startet erst, wenn die Linie gut im Bild ist; mobil jede Station einzeln ---------- */
  function initTimeline(root) {
    $$('[data-ss-tl]', root).forEach(function (sec) {
      var track = sec.querySelector('.ss-tl__track'), stops = $$('.ss-tl__stop', sec);
      if (noanim(sec) || !track) { sec.classList.add('is-in'); stops.forEach(function (s) { s.classList.add('is-in'); }); return; }
      if (mqSmall.matches) stops.forEach(function (s) { onView(s, function () { s.classList.add('is-in'); }, '0px 0px -22% 0px'); });
      else onView(track, function () { sec.classList.add('is-in'); }, '0px 0px -28% 0px');
    });
    /* Smartphone-Gespräch: erst, wenn das Telefon selbst gut im Bild ist */
    $$('[data-ss-ch]', root).forEach(function (sec) {
      var phone = sec.querySelector('.ss-ch__phone');
      if (noanim(sec) || !phone) { sec.classList.add('is-in'); return; }
      /* startet, sobald die erste Nachricht ins Bild rückt */
      onView(phone.querySelector('.ss-ch__msg') || phone, function () { sec.classList.add('is-in'); }, '0px 0px -12% 0px');
    });
    /* Rollen: am Desktop fächert der Stapel auf, mobil kommt jede Scheibe einzeln */
    $$('[data-ss-ro]', root).forEach(function (sec) {
      var deck = sec.querySelector('.ss-ro__deck'), cards = $$('.ss-ro__card', sec);
      if (noanim(sec) || !deck) { sec.classList.add('is-in'); return; }
      if (mqSmall.matches) cards.forEach(function (c) { onView(c, function () { c.classList.add('is-in'); }, '0px 0px -15% 0px'); });
      else onView(deck, function () { sec.classList.add('is-in'); }, '0px 0px -35% 0px');
    });
  }

  /* ---------- Zahl zählt hoch, sobald ihre Scheibe im Bild ist ---------- */
  function initCount(root) {
    $$('[data-ss-count]', root).forEach(function (el) {
      var to = parseInt(el.getAttribute('data-ss-count'), 10);
      if (noanim(el) || !(to > 0)) return;
      el.textContent = '0';
      onView(el, function () {
        setTimeout(function () {
          var t0 = performance.now(), last = -1, dur = 1300;
          var step = function (now) { var p = clamp((now - t0) / dur, 0, 1); var v = Math.round(to * (1 - Math.pow(1 - p, 3))); if (v !== last) { el.textContent = v; last = v; } if (p < 1) requestAnimationFrame(step); };
          requestAnimationFrame(step);
        }, 650);
      }, '0px');
    });
  }

  /* ---------- Erster Eindruck: Uhr läuft, die Ziele haken sich im Takt ab (CSS) ---------- */
  function initEindruck(root) {
    $$('[data-ss-ei]', root).forEach(function (sec) {
      var els = $$('[data-ss-timer]', sec), el = els[0], list = sec.querySelector('.ss-ei__list');
      var secs = parseInt(el && el.getAttribute('data-ss-timer'), 10) || 3;
      sec.style.setProperty('--t', secs + 's');
      if (!el || noanim(sec)) { sec.classList.add('is-run'); return; }
      els.forEach(function (e) { e.textContent = '0,0'; });
      var started = false;
      var run = function () {
        if (started) return; started = true;
        sec.classList.add('is-run');
        var t0 = performance.now(), last = '';
        var step = function (now) { var v = clamp((now - t0) / 1000, 0, secs); var s = v.toFixed(1).replace('.', ','); if (s !== last) { els.forEach(function (e) { e.textContent = s; }); last = s; } if (v < secs) requestAnimationFrame(step); };
        requestAnimationFrame(step);
      };
      if (mqSmall.matches && list) {
        /* mobil: starten, sobald die ganze Liste im Bild ist – oder spätestens, bevor die Uhr unter die Kopfzeile rutscht */
        var chip = els.length > 1 ? els[1].closest('.ss-ei__timer') : null, hd = document.querySelector('.ss-hd');
        updaters.push(function (vh) {
          if (started) return;
          var lb = R(list).bottom, ct = chip ? R(chip).top : 0, hb = hd ? R(hd).bottom : 0;
          if (R(list).top < vh && (lb <= vh - 12 || (chip && ct <= hb + 16))) run();
        });
        request();
      } else onView(list || sec, run, '0px 0px -45% 0px');
    });
  }

  /* ---------- Kopfzeile, Menü, Randstreifen ---------- */
  function initHeader() {
    var hd = document.querySelector('[data-ss-header]'); if (!hd) return;
    if (!cfg.editor) ['t', 'b'].forEach(function (k) { var s = document.createElement('div'); s.className = 'ss-edgestrip ss-edgestrip--' + k; s.setAttribute('aria-hidden', 'true'); document.body.appendChild(s); });
    var first = document.querySelector('#MainContent > .shopify-section');
    var limit = 0;
    /* Desktop mit Hero-Bühne: Kopfzeile steht von Anfang an fest und bleibt während des Scrollcrafts unverändert; erst nach dem Hero kommt der Glas-Hintergrund (ohne Größenwechsel) */
    measurers.push(function () { var pin = !!(SCRUB && first && first.querySelector('[data-ss-hero]')); doc.classList.toggle('ss-hd-pinned', pin); limit = first ? (pin ? first.offsetTop + first.offsetHeight - 80 : Math.min(first.offsetTop + first.offsetHeight - 80, first.offsetTop + window.innerHeight * 1.1)) : 400; });
    updaters.push(function () { var y = window.scrollY; doc.classList.toggle('ss-scrolled', y > limit); });
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    var setOpen = function (li, open) {
      if (open) $$('.ss-hd__has.is-open', hd).forEach(function (o) { if (o !== li) setOpen(o, false); });
      li.classList.toggle('is-open', open); var b = li.querySelector('.ss-hd__drop'); if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    $$('.ss-hd__has', hd).forEach(function (li) {
      var b = li.querySelector('.ss-hd__drop'), timer = 0;
      li.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'mouse' || !finePointer.matches) return; clearTimeout(timer); setOpen(li, true); });
      li.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'mouse' || !finePointer.matches) return; clearTimeout(timer); timer = setTimeout(function () { setOpen(li, false); }, 280); });
      if (b) b.addEventListener('click', function (e) { e.stopPropagation(); if (finePointer.matches && li.classList.contains('is-open') && li.matches(':hover') && e.detail > 0) return; setOpen(li, !li.classList.contains('is-open')); });
      li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) setOpen(li, false); });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.ss-hd__has')) $$('.ss-hd__has.is-open', hd).forEach(function (o) { setOpen(o, false); }); });
    var burger = hd.querySelector('.ss-hd__burger');
    var setMenu = function (open) { doc.classList.toggle('ss-menu-open', open); burger.setAttribute('aria-expanded', open ? 'true' : 'false'); burger.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen'); };
    if (burger) burger.addEventListener('click', function () { setMenu(!doc.classList.contains('ss-menu-open')); });
    $$('.ss-menu a', hd).forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key !== 'Escape') return; if (doc.classList.contains('ss-menu-open')) { setMenu(false); burger.focus(); } $$('.ss-hd__has.is-open', hd).forEach(function (o) { setOpen(o, false); }); });
  }

  /* ---------- Fußzeile: Spalten mobil zuklappen ---------- */
  function initFooter() {
    var cols = $$('.ss-ft__col');
    var set = function () { cols.forEach(function (c) { if (mqSmall.matches) c.removeAttribute('open'); else c.setAttribute('open', ''); }); };
    set(); if (mqSmall.addEventListener) mqSmall.addEventListener('change', set);
    cols.forEach(function (c) { c.querySelector('summary').addEventListener('click', function (e) { if (!mqSmall.matches) e.preventDefault(); }); });
  }

  function init(root) {
    initReveal(root); initInView(root); initSplit(root); initWords(root); initSlot(root); initHero(root); initSk(root); initTimeline(root); initCount(root); initEindruck(root); initUmkehr(root); initMarquee(root);
    initTilt(root); initSkScenes(root); initGeraete(root); initStapel(root); initVergleich(root); initWiderruf(root); initTypeOnce(root); initClock(root); initAcc(root); initFilter(root); initScrollShots(root); initLightbox(root); initSliders(root);
    initConsent(root); initToc(root); initKonfig(root);
  }
  function boot() {
    initHeader(); init(document); initFooter();
    measurers.forEach(function (m) { m(); }); request();
    window.SS_READY = true;
    window.addEventListener('load', function () { measurers.forEach(function (m) { m(); }); request(); });
    /* Sprungziel nachführen, solange niemand selbst gescrollt hat */
    (function hashFix() {
      var id = decodeURIComponent((location.hash || '').slice(1)); if (!id) return;
      var moved = false, stop = function () { moved = true; };
      ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { window.addEventListener(ev, stop, { passive: true, once: true }); });
      var go = function () { if (moved) return; var el = document.getElementById(id); if (el) el.scrollIntoView({ block: 'start' }); };
      window.addEventListener('load', function () { go(); setTimeout(go, 400); setTimeout(go, 1200); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(go);
    })();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measurers.forEach(function (m) { m(); }); request(); });
    if ('ResizeObserver' in window) new ResizeObserver(function () { measurers.forEach(function (m) { m(); }); request(); }).observe(document.body);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); measurers.forEach(function (m) { m(); }); request(); });
})();
